import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { OwnBoxPackaging, PackagingRateItemData } from '../../models/rate.types';
import { PackagingPricesTable } from '../interaction/PackagingPricesTable';

interface PackagingDataDisplayProps {
  data: PackagingRateItemData;
  ownBoxes?: OwnBoxPackaging[];
}

export const PackagingDataDisplay = ({ data, ownBoxes = [] }: PackagingDataDisplayProps) => {
  const { t } = useTranslation('ratesModule');

  const prices = useMemo(() => {
    const map: Record<number, number> = {};
    for (const entry of data.items ?? []) {
      map[entry.packaging_id] = entry.price;
    }
    return map;
  }, [data.items]);

  const displayBoxes = useMemo(() => {
    const boxMap = new Map(ownBoxes.map((box) => [box.id, box]));

    for (const entry of data.items ?? []) {
      if (!boxMap.has(entry.packaging_id)) {
        boxMap.set(entry.packaging_id, {
          id: entry.packaging_id,
          name: t('sections.packagingPrices.unknownBox', { id: entry.packaging_id }),
          pvp: null,
        });
      }
    }

    if (ownBoxes.length > 0) {
      return ownBoxes;
    }

    return Array.from(boxMap.values());
  }, [ownBoxes, data.items, t]);

  if (!data.items?.length) {
    return <p className="text-sm text-subtext">{t('itemData.noData')}</p>;
  }

  return <PackagingPricesTable ownBoxes={displayBoxes} prices={prices} onPriceChange={() => {}} readOnly />;
};
